import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit'
import { RootState } from '../../../app/store'
import fetchAPI from '../../../common/fetchAPI'
import { ExpensePolicyRuleStateClass } from './interfaces/expensePolicyRuleStateClass';
import { sortData } from '../../../common/timeLiveFunction';
import { FALSE } from 'sass';


const initialState: ExpensePolicyRuleStateClass = {
    isLoading: false,
    status: 'idle',
    expensePolicyRuleList: [],
    selectedRecord: {},
    isReload: false,
    sortOrder: 'asc',
    sortColumn: 'PolicyRuleName',
    search: '',
    pageNo: 1,
    pageSize: 10
}
interface IThunkApi {
    state: {
        expensePolicyRule: ExpensePolicyRuleStateClass;
    },
}

export const getAccountExpensePolicyRuleAsync = createAsyncThunk

    <any, any, IThunkApi>
    (
        'expensePolicyRule/getAccountExpensePolicyRule',
        async (arg, thunkApi) => {
            const response = await fetchAPI('api/v2/ExpensePolicyRules/GetDataForAccountExpensePolicyRule/' + arg, 'Get', '', true, 'a73f036e-6d84-440b-85e0-70e157c5eef7');
            const json = await response.json();
            return json;
        }
    )

export const getAccountExpensePolicyRuleByExpensePolicyRuleIdAsync = createAsyncThunk

    <any, any, IThunkApi>
    (
        'expensePolicyRule/getAccountExpensePolicyRuleByExpensePolicyRuleId',
        async (arg, thunkApi) => {
            const response = await fetchAPI('api/v2/ExpensePolicyRules/GetDataAccountExpensePolicyRuleById/' + arg, 'Get', '', true, 'a73f036e-6d84-440b-85e0-70e157c5eef7');
            const json = await response.json();
            return json;
        }
    )
export const addAccountExpensePolicyRuleAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        'expensePolicyRule/addAccountExpensePolicyRule',
        async (arg, thunkApi) => {
          
            const response = await fetchAPI('api/v2/ExpensePolicyRules/InsertAccountExpensePolicyRule', 'POST', arg,
                true, 'a73f036e-6d84-440b-85e0-70e157c5eef7');
            const json = await response.json();
            return json;
        }
    )

export const updateAccountExpensePolicyRulesAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        'expensePolicyRule/updateAccountExpensePolicyRules',
        async (arg, thunkApi) => {
            const { AccountExpensePolicyRuleId, AccountExpensePolicyId, PolicyRuleName,
                SystemExpenseRuleTypeId, SystemExpenseLimitTypeId, PolicyRuleValue,
                IsExpenseCategoryId, AccountExpenseCategoryOrTypeId, IsDisabled } = arg;
            const response = await fetchAPI('api/v2/ExpensePolicyRules/UpdateAccountExpensePolicyRules/' + AccountExpensePolicyRuleId, 'Put',
                {
                    AccountExpensePolicyId: AccountExpensePolicyId, PolicyRuleName: PolicyRuleName,
                    SystemExpenseRuleTypeId: SystemExpenseRuleTypeId, SystemExpenseLimitTypeId: SystemExpenseLimitTypeId,
                    PolicyRuleValue: PolicyRuleValue, IsExpenseCategoryId: IsExpenseCategoryId,
                    AccountExpenseCategoryOrTypeId: AccountExpenseCategoryOrTypeId,
                    IsDisabled:IsDisabled
                },
                true, 'a73f036e-6d84-440b-85e0-70e157c5eef7');
            const json = await response.json();
            return json;
        }
    )

export const deleteAccountExpensePolicyRulesAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        'expensePolicyRule/deleteAccountExpensePolicyRules',
        async (arg, thunkApi) => {
            const response = await fetchAPI('api/v2/ExpensePolicyRules/DeleteAccountExpensePolicyRules/' + arg, 'DELETE', '', true, 'a73f036e-6d84-440b-85e0-70e157c5eef7');
            const json = await response.json();
            return json;
        }
    )
    export const deleteAllSelectedRecordExpensePolicyRuleAsync = createAsyncThunk
    <any,any,IThunkApi>
    (
        "expensePolicyRule/DeleteAllSelectedRecordExpensePolicyRule",
        async(arg,thunkApi) =>{
            const response = await fetchAPI('api/v2/ExpensePolicyRules/DeleteAllSelectedRecordExpensePolicyRule/', 'DELETE', arg, true,'a73f036e-6d84-440b-85e0-70e157c5eef7');
            const json =await response.json();
            return json;        
        }
    )

    

export const expensePolicyRuleSlice = createSlice({
    name: 'expensePolicyRule',
    initialState,
    reducers: {
        resetSelectedRecordObjectInState: (state) => {
            state.selectedRecord = {};
        },  
        checkedState: (state, action) => {
            const currentindex = state.expensePolicyRuleList.findIndex((item) => item.AccountExpensePolicyRuleId == action.payload);
            const newArray = [...state.expensePolicyRuleList];
            newArray[currentindex] = { ...newArray[currentindex], isSelected : 1 };
            state.expensePolicyRuleList = newArray;
        },
        unCheckedState: (state, action) => {
            const currentindex = state.expensePolicyRuleList.findIndex((item) => item.AccountExpensePolicyRuleId == action.payload);
            const newArray = [...state.expensePolicyRuleList];
            newArray[currentindex] = { ...newArray[currentindex], isSelected: 0 };
            state.expensePolicyRuleList = newArray;
        },
        checkedAllState: (state) => {
            const newArray = state.expensePolicyRuleList.map((item) => ({
                ...item,
                isSelected: 1,
            }));
            state.expensePolicyRuleList = newArray;
        },
        unCheckedAllState: (state) => {
            const newArray = state.expensePolicyRuleList.map((item) => ({
                ...item,
                isSelected: 0,
            }));
            state.expensePolicyRuleList = newArray;
        },
        updatePagination: (state, action: PayloadAction<any>) => {
            state.pageSize = action.payload.pageSize;
            state.pageNo = action.payload.pageNo;
            state.search = action.payload.search;
        },
        updateSorting: (state, action) => {
            state.sortOrder = action.payload.sortOrder;
            state.sortColumn = action.payload.sortColumn;
            state.pageSize = action.payload.pageSize;
            state.pageNo = action.payload.pageNo;
            let tempArray = state.expensePolicyRuleList;
            state.expensePolicyRuleList = sortData(tempArray, action.payload.sortOrder, action.payload.sortColumn);
        }
    },
    extraReducers: (builder) => {
        builder
           
            .addCase(getAccountExpensePolicyRuleAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;

            })
            .addCase(getAccountExpensePolicyRuleAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.isLoading = false;
                
                if (Object.keys(payload.data).length === 0) {
                    state.expensePolicyRuleList = [];
                } else {
                    state.expensePolicyRuleList = payload.data;
                    state.expensePolicyRuleList.map((item: any) => {
                        item.isSelected = 0
                    });
                }
                state.isReload = false;
                state.selectedRecord = {};
            })
            .addCase(getAccountExpensePolicyRuleAsync.rejected, (state) => {
                state.status = 'failed';
                state.isLoading = false;

            })
            .addCase(getAccountExpensePolicyRuleByExpensePolicyRuleIdAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;

            })
            .addCase(getAccountExpensePolicyRuleByExpensePolicyRuleIdAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.isLoading = false;

                state.selectedRecord = payload.data[0];
            })
            .addCase(getAccountExpensePolicyRuleByExpensePolicyRuleIdAsync.rejected, (state) => {
                state.status = 'failed';
                state.isLoading = false;

            })
            .addCase(addAccountExpensePolicyRuleAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;

            })
            .addCase(addAccountExpensePolicyRuleAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.isReload = true;
                state.isLoading = false;

            })
            .addCase(addAccountExpensePolicyRuleAsync.rejected, (state) => {
                state.status = 'failed';
                state.isLoading = false;

            })

            .addCase(updateAccountExpensePolicyRulesAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;

            })
            .addCase(updateAccountExpensePolicyRulesAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.isReload = true;
                state.isLoading = false;

            })
            .addCase(updateAccountExpensePolicyRulesAsync.rejected, (state) => {
                state.status = 'failed';
                state.isLoading = false;

            })
            .addCase(deleteAccountExpensePolicyRulesAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;

            })
            .addCase(deleteAccountExpensePolicyRulesAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.isReload = true;
                state.isLoading = false;

            })
            .addCase(deleteAccountExpensePolicyRulesAsync.rejected, (state) => {
                state.status = 'failed';
                state.isLoading = false;

            })
            
            .addCase(deleteAllSelectedRecordExpensePolicyRuleAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;


            })
            .addCase(deleteAllSelectedRecordExpensePolicyRuleAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.isReload = true;
                state.isLoading = false;

            })
            .addCase(deleteAllSelectedRecordExpensePolicyRuleAsync.rejected, (state) => {
                state.status = 'failed';
                state.isLoading = false;

            })
    }
})
export const {
    resetSelectedRecordObjectInState,checkedState, unCheckedState, checkedAllState, unCheckedAllState,updatePagination,updateSorting
} = expensePolicyRuleSlice.actions
export const expensePolicyRuleStateClass = (state: RootState) => state.expensePolicyRule
export default expensePolicyRuleSlice.reducer